import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Container } from './components/Styled'
import { Title } from '../Styled'
import { Item } from './components/Item'
import { ReviewsProvider } from 'components/Reviews'
import { Link } from 'react-router-dom'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { fetchOrders } from 'lib/core/data/customer/orders'
import { useOrders } from 'lib/core/hooks'

export const OrderHistory = () => {
  const { isFetching, orders } = useOrders()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchOrders())
  }, [dispatch])

  return (
    <Container>
      <ReviewsProvider>
        <FlexWrapper className='flex-title'>
          <Title>
            Recent Orders
          </Title>
          <Link to='/customer/account'>Back</Link>
        </FlexWrapper>
        {!orders.length && !isFetching && (
          <p>Nothing here yet!</p>
        )}
        {orders.map((order) => {
          return (
            <Item
              key={order.id}
              order={order}
            />
          )
        })}
      </ReviewsProvider>
    </Container>
  )
}
